/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VorlagenwechselBericht
 */
export interface VorlagenwechselBericht {
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselBericht
     */
    neueDatenbankId?: string;
    /**
     * 
     * @type {string}
     * @memberof VorlagenwechselBericht
     */
    neueDatenbankName?: string;
    /**
     * 
     * @type {number}
     * @memberof VorlagenwechselBericht
     */
    eintraege?: number;
    /**
     * 
     * @type {number}
     * @memberof VorlagenwechselBericht
     */
    neueFelder?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VorlagenwechselBericht
     */
    neueFeldNamen?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof VorlagenwechselBericht
     */
    uebertrageneDateien?: number;
    /**
     * 
     * @type {number}
     * @memberof VorlagenwechselBericht
     */
    abgewaehlteFelder?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VorlagenwechselBericht
     */
    hinweise?: Array<string>;
}

/**
 * Check if a given object implements the VorlagenwechselBericht interface.
 */
export function instanceOfVorlagenwechselBericht(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VorlagenwechselBerichtFromJSON(json: any): VorlagenwechselBericht {
    return VorlagenwechselBerichtFromJSONTyped(json, false);
}

export function VorlagenwechselBerichtFromJSONTyped(json: any, ignoreDiscriminator: boolean): VorlagenwechselBericht {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'neueDatenbankId': !exists(json, 'neueDatenbankId') ? undefined : json['neueDatenbankId'],
        'neueDatenbankName': !exists(json, 'neueDatenbankName') ? undefined : json['neueDatenbankName'],
        'eintraege': !exists(json, 'eintraege') ? undefined : json['eintraege'],
        'neueFelder': !exists(json, 'neueFelder') ? undefined : json['neueFelder'],
        'neueFeldNamen': !exists(json, 'neueFeldNamen') ? undefined : json['neueFeldNamen'],
        'uebertrageneDateien': !exists(json, 'uebertrageneDateien') ? undefined : json['uebertrageneDateien'],
        'abgewaehlteFelder': !exists(json, 'abgewaehlteFelder') ? undefined : json['abgewaehlteFelder'],
        'hinweise': !exists(json, 'hinweise') ? undefined : json['hinweise'],
    };
}

export function VorlagenwechselBerichtToJSON(value?: VorlagenwechselBericht | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'neueDatenbankId': value.neueDatenbankId,
        'neueDatenbankName': value.neueDatenbankName,
        'eintraege': value.eintraege,
        'neueFelder': value.neueFelder,
        'neueFeldNamen': value.neueFeldNamen,
        'uebertrageneDateien': value.uebertrageneDateien,
        'abgewaehlteFelder': value.abgewaehlteFelder,
        'hinweise': value.hinweise,
    };
}

